// extracted by mini-css-extract-plugin
module.exports = {"main":"Favourites_main__VChd8","backbutton":"Favourites_backbutton__3MiZU","gallery":"Favourites_gallery__20vbw"};